import ApiClient from '@afosto/api/ApiClient';

class Profile {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Upsert new a profile definition
   *
   * @param {string} path - the key we want to register
   * @param {Object} body - Announce a profile definition for a given path
   * @param {Object} options - The additional request options
   * @description Announce an new profile
   * @returns {Promise}
   */
  announceProfile(path, body, options = {}) {
    return this.apiClient.request({
      url: `/iam/profiles/${path}/announce`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Get all the profiles that match the path
   *
   * @param {string} path - The correlationID of a configuration where we are updating the configuration off
   * @param {Object} query - The optional path parameters
   * @param {string} [query.channelId] - the channel_id to resolve the channel in the path for
   * @param {Object} options - The additional request options
   * @description Get the profiles by its key
   * @returns {Promise}
   */
  getProfile(path, query = {}, options = {}) {
    const params = {
      channel_id: query.channelId,
    };

    return this.apiClient.request({
      url: `/iam/profiles/${path}`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Get the definition for a profile
   *
   * @param {string} path - the key we want to register
   * @param {Object} options - The additional request options
   * @description Announce new profiles
   * @returns {Promise}
   */
  getProfileDefinitions(path, options = {}) {
    return this.apiClient.request({
      url: `/iam/profiles/${path}/definition`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Update the profile&#39;s content
   *
   * @param {string} path - The correlationID of a configuration where we are updating the configuration off
   * @param {Object} body - update a profile
   * @param {Object} query - The optional path parameters
   * @param {string} [query.channelId] - the channel_id to resolve the channel in the path for
   * @param {Object} options - The additional request options
   * @description Update the profile content
   * @returns {Promise}
   */
  updateProfile(path, body, query = {}, options = {}) {
    const params = {
      channel_id: query.channelId,
    };

    return this.apiClient.request({
      url: `/iam/profiles/${path}`,
      method: 'put',
      params,
      data: body,
      ...options,
    });
  }
}

export const profile = new Profile();

export default Profile;
